/**
 * @generated SignedSource<<9b96502cfebeb0be69ff815033537cde>>
 * @relayHash acb311ee6140c9f06af97454bc604d92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 96e8d38dc5c99ce9f243664e7fea612f83546c86c739f04163f307f852372be8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoard_JiraBoardQuery } from './JiraBoard_JiraBoardQuery.graphql';

import isAssignAgentsInlineM2TechnicalEnabled_provider from '@jira/board__relay-providers/src/AssignAgentsInlineM2TechnicalRelayprovider';
import isAutoManagedSprintsEnabled_provider from '@jira/board__relay-providers/src/AutoManagedSprintsForHarmonisedBoard';
import isBulkIssueActionsEnabled_provider from '@jira/board__relay-providers/src/BoardBulkIssueActionsEnabled';
import shouldHandleProjectWithoutBaseIssueType_provider from '@jira/board__relay-providers/src/BoardHandleProjectWithoutBaseIssueType';
import withBoardM3_provider from '@jira/board__relay-providers/src/BoardHarmonisationMilestone3';
import boardInlineAssignAgent_provider from '@jira/board__relay-providers/src/BoardInlineAssignAgent';
import shouldPublishRovoBoardContext_provider from '@jira/board__relay-providers/src/BoardRovoContextualActions';
import withSwimlanesChangeboarding_provider from '@jira/board__relay-providers/src/SwimlanesChangeboarding';
import withTmpHarmonisationOnboarding_provider from '@jira/board__relay-providers/src/TmpHarmonisationOnboarding';

const node: PreloadableConcreteRequest<JiraBoard_JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "96e8d38dc5c99ce9f243664e7fea612f83546c86c739f04163f307f852372be8",
    "metadata": {},
    "name": "JiraBoard_JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": withSwimlanesChangeboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": withTmpHarmonisationOnboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": isAutoManagedSprintsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardRovoContextualActionstsx": shouldPublishRovoBoardContext_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardBulkIssueActionsEnabledtsx": isBulkIssueActionsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHarmonisationMilestone3tsx": withBoardM3_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignAgentsInlineM2TechnicalRelayprovidertsx": isAssignAgentsInlineM2TechnicalEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": boardInlineAssignAgent_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHandleProjectWithoutBaseIssueTypetsx": shouldHandleProjectWithoutBaseIssueType_provider
    }
  }
};

export default node;
